module.exports = __webpack_public_path__ + "img/tooth16.a491c88c.png";